module.exports = __webpack_public_path__ + "img/aw-desktop-default.1dc0db81.png";